/** A text field. `search` adds the glass and lays it out as a pill. Labels come from Field or an aria-label. */
import type { InputHTMLAttributes } from 'react'
import { cx } from '../cx'
import { Icon } from './Icon'
import s from './Input.module.css'

type Native = Omit<InputHTMLAttributes<HTMLInputElement>, 'className' | 'style'>

export function Input({ search, mono, ...rest }: Native & { search?: boolean; mono?: boolean }) {
  if (search) {
    return (
      <span className={s.search}>
        <Icon name="search" size="sm" />
        <input type="search" {...rest} className={s.bare} />
      </span>
    )
  }
  return <input {...rest} className={cx(s.input, mono && s.mono)} />
}
